module.exports = __webpack_public_path__ + "img/top1.18da5a54.gif";